import * as BaseAPI from '@/api/baseAPI';
import ReportType from "../../../shared/models/reportType";

export async function getReportTypes(): Promise<ReportType[]> {
  const result = await BaseAPI.simpleGet(`/reporttypes`);
  return result.data;
}